import { computed, ComputedRef } from "vue";
import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
import { GetHousesByQuery } from "@/types/GetHousesByQuery";
import { IBuilderEstimatorFormData } from "@/types/BuilderEstimatorFormData";
import { generateHouseQuery } from "@/helpers/generateHouseQuery";

type StepAction = {
  action: () => boolean | void;
};

type StepsWithActions =
  | BuilderEstimatorSteps.SELECT_DESIGN
  | BuilderEstimatorSteps.VIEW_DESIGN;

interface IBuilderEstimatorStepActions {
  stepActions: ComputedRef<{
    [K in BuilderEstimatorSteps]?: StepAction;
  }>;
  nextStepAction: (currentStep: BuilderEstimatorSteps) => void;
}

export const useBuilderEstimatorStepActions = (
  formData: IBuilderEstimatorFormData,
  builderId: string,
  getHouses: (query?: GetHousesByQuery) => void
): IBuilderEstimatorStepActions => {
  const updateSelectedHouse = (): void => {
    const { landWidth, landDepth } =
      formData[BuilderEstimatorSteps.LAND_DETAILS];
    const query = generateHouseQuery(builderId, landWidth, landDepth);

    getHouses(query);
  };

  const stepActions = computed<Record<StepsWithActions, StepAction>>(() => ({
    [BuilderEstimatorSteps.SELECT_DESIGN]: {
      action: updateSelectedHouse,
    },
    [BuilderEstimatorSteps.VIEW_DESIGN]: {
      action: updateSelectedHouse,
    },
  }));

  const nextStepAction = (currentStep: BuilderEstimatorSteps): void => {
    const isStepWithAction = currentStep in stepActions.value;

    if (!isStepWithAction) return;

    stepActions.value[currentStep as StepsWithActions].action();
  };

  return {
    stepActions,
    nextStepAction,
  };
};
